import { PublicBarberQuery } from '@water-web/api';

export const PublicBarberConstructor = (apiUrl: string) => ({
  byId: new PublicBarberQuery(apiUrl),
});
